export default function getactivationcardReducer(state = { activationcardState: []}, action) {
    switch (action.type) {
        case 'ACTIVATIONCARD_STATE':
            return {
                activationcardState: action.activationcardState,
            }

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/getactivationcardReducer.jsx